var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.tags.length
    ? _c("div", { staticClass: "viewport", attrs: { "aria-hidden": "true" } }, [
        _c(
          "p",
          { staticClass: "menu-tag-legend" },
          _vm._l(_vm.tags, function (tag) {
            return _c("menu-tag", {
              key: tag.mt_id,
              attrs: { tag: tag, "menu-type": _vm.menuType || "visual" },
            })
          }),
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }